import { render } from "./VideoItem.vue?vue&type=template&id=1761958d&scoped=true"
import script from "./VideoItem.vue?vue&type=script&lang=js"
export * from "./VideoItem.vue?vue&type=script&lang=js"

import "./VideoItem.vue?vue&type=style&index=0&id=1761958d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1761958d"]])

export default __exports__